import { Show, type JSX } from 'solid-js'

import Modal from '../ui/Modal'
import EditModalFooter from './EditModalFooter'

type EditEntryModalProps = {
   id: string
   open: boolean
   title: string
   error: string
   saveId: string
   cancelId: string
   onSave: () => void
   onCancel: () => void
   /** Deletes the entry being edited; omitted hides the Delete button. */
   onDelete?: () => void
   deleteId?: string
   /** Delete button text (defaults to "Delete"). */
   deleteLabel?: string
   children: JSX.Element
}

/**
 * Renders the shell shared by the entry edit modals: conditional mount, title,
 * the caller's fields, and the error + Save/Cancel (+ Delete) footer.
 *
 * @param props - Modal ids, open state, title, error, handlers, and field children.
 * @returns The modal element.
 */
const EditEntryModal = (props: EditEntryModalProps) => (
   <Show when={props.open}>
      <Modal id={props.id} onDismiss={props.onCancel}>
         <h2 class="text-2xl font-bold">{props.title}</h2>
         {props.children}
         <EditModalFooter
            error={props.error}
            saveId={props.saveId}
            cancelId={props.cancelId}
            onSave={props.onSave}
            onCancel={props.onCancel}
            onDelete={props.onDelete}
            deleteId={props.deleteId}
            deleteLabel={props.deleteLabel}
         />
      </Modal>
   </Show>
)

export default EditEntryModal
